const swiperSliders = document.querySelectorAll(".wp-block-lg-blocks-swiper-slider");
swiperSliders.forEach(swiperSlider => {
  let swiperConfig = swiperSlider.dataset.swiperConfig;
  swiperConfig = JSON.parse(swiperConfig);
  console.log(swiperConfig);
  new Swiper(swiperSlider, swiperConfig);
});


